const CHECKLIST = [
  {
    label: 'Checkbox 1',
    checked: true,
  },
  {
    label: 'Checkbox 2',
    checked: true,
  },
  {
    label: 'Checkbox 3',
    checked: true,
  },
  {
    label: 'Checkbox 4',
    checked: false,
  },
  {
    label: 'Checkbox 5',
    checked: false,
  },
];

const ALLCHECKLIST = [
  {
    title: "Ma checklist d'arrivée",
    subtitle: 'Mes prochaines actions',
    checkboxes: [
      {
        label: 'Checkbox 1',
        checked: true,
      },
      {
        label: 'Checkbox 2',
        checked: true,
      },
      {
        label: 'Checkbox 3',
        checked: true,
      },
      {
        label: 'Checkbox 4',
        checked: false,
      },
      {
        label: 'Checkbox 5',
        checked: false,
      },
    ],
  },
  {
    title: 'Ma checklist de départ',
    subtitle: 'Faire les prochaines actions',
    checkboxes: [
      {
        label: 'Checkbox 1',
        checked: true,
      },
      {
        label: 'Checkbox 2',
        checked: false,
      },
      {
        label: 'Checkbox 3',
        checked: false,
      },
      {
        label: 'Checkbox 4',
        checked: false,
      },
      {
        label: 'Checkbox 5',
        checked: false,
      },
    ],
  },
];

const NEWS: Array<any> = [
  {
    id: 2150,
    date: '2021-11-25T11:45:42',
    date_gmt: '2021-11-25T10:45:42',
    guid: {
      rendered: 'http://localhost:8001/?p=2150',
    },
    modified: '2021-11-25T11:45:42',
    modified_gmt: '2021-11-25T10:45:42',
    slug: 'tangi-test-notifs-preprod-les-emails-ok',
    status: 'publish',
    type: 'post',
    link: 'http://localhost:8001/tangi-test-notifs-preprod-les-emails-ok/',
    title: {
      rendered: 'Tangi &#8211; Test notifs préprod &#8211; les emails ok ?',
    },
    content: {
      rendered:
        '<p>Haec igitur lex in amicitia sanciatur, ut neque rogemus res turpes nec faciamus rogati. Turpis enim excusatio est et minime accipienda cum in ceteris peccatis, tum si quis contra rem publicam se amici causa fecisse fateatur. Etenim eo loco, Fanni et Scaevola, locati sumus ut nos longe prospicere oporteat futuros casus rei publicae. Deflexit iam aliquantum de spatio curriculoque consuetudo maiorum.<br />\nQuibus ita sceleste patratis Paulus cruore perfusus reversusque ad principis castra multos coopertos paene catenis adduxit in squalorem deiectos atque maestitiam, quorum adventu intendebantur eculei uncosque parabat carnifex et tormenta. et ex is proscripti sunt plures actique in exilium alii, non nullos gladii consumpsere poenales. nec enim quisquam facile meminit sub Constantio, ubi susurro tenus haec movebantur, quemquam absolutum.<br />\nItaque verae amicitiae difficillime reperiuntur in iis qui in honoribus reque publica versantur; ubi enim istum invenias qui honorem amici anteponat suo? Quid? Haec ut omittam, quam graves, quam difficiles plerisque videntur calamitatum societates! Ad quas non est facile inventu qui descendant. Quamquam Ennius recte.<br />\nFieri, inquam, Triari, nullo pacto potest, ut non dicas, quid non probes eius, a quo dissentias. quid enim me prohiberet Epicureum esse, si probarem, quae ille diceret? cum praesertim illa perdiscere ludus esset. Quam ob rem dissentientium inter se reprehensiones non sunt vituperandae, maledicta, contumeliae, tum iracundiae, contentiones concertationesque in disputando pertinaces indignae philosophia mihi videri solent.<br />\nAlios autem dicere aiunt multo etiam inhumanius (quem locum breviter paulo ante perstrinxi) praesidii adiumentique causa, non benevolentiae neque caritatis, amicitias esse expetendas; itaque, ut quisque minimum firmitatis haberet minimumque virium, ita amicitias appetere maxime; ex eo fieri ut mulierculae magis amicitiarum praesidia quaerant quam viri et inopes quam opulenti et calamitosi quam ii qui putentur beati.</p>\n',
      protected: false,
    },
    excerpt: {
      rendered:
        '<p>Haec igitur lex in amicitia sanciatur, ut neque rogemus res turpes nec faciamus rogati. Turpis &#8230;</p>\n',
      protected: false,
    },
    author: 37,
    featured_media: 259,
    comment_status: 'closed',
    ping_status: 'closed',
    sticky: false,
    template: '',
    /*  format: 'standard', */
    meta: [],
    categories: [2],
    tags: [],
    'tax-house': [23],
    fimg_url:
      'http://localhost:8001/wp-content/uploads/2021/08/0290ac103740859.5f53a16d1ad98.png',
    acf: {
      house: [
        {
          term_id: 23,
          name: 'Cité',
          slug: 'cite',
          term_group: 0,
          term_taxonomy_id: 23,
          taxonomy: 'tax-house',
          description: '',
          parent: 0,
          count: 44,
          filter: 'raw',
        },
      ],
      alert: false,
    },
    _links: {
      self: [
        {
          href: 'http://localhost:8001/wp-json/wp/v2/posts/2150',
        },
      ],
      collection: [
        {
          href: 'http://localhost:8001/wp-json/wp/v2/posts',
        },
      ],
      about: [
        {
          href: 'http://localhost:8001/wp-json/wp/v2/types/post',
        },
      ],
      author: [
        {
          embeddable: true,
          href: 'http://localhost:8001/wp-json/wp/v2/users/37',
        },
      ],
      replies: [
        {
          embeddable: true,
          href: 'http://localhost:8001/wp-json/wp/v2/comments?post=2150',
        },
      ],
      'version-history': [
        {
          count: 1,
          href: 'http://localhost:8001/wp-json/wp/v2/posts/2150/revisions',
        },
      ],
      'predecessor-version': [
        {
          id: 2152,
          href: 'http://localhost:8001/wp-json/wp/v2/posts/2150/revisions/2152',
        },
      ],
      'wp:featuredmedia': [
        {
          embeddable: true,
          href: 'http://localhost:8001/wp-json/wp/v2/media/259',
        },
      ],
      'wp:attachment': [
        {
          href: 'http://localhost:8001/wp-json/wp/v2/media?parent=2150',
        },
      ],
      'wp:term': [
        {
          taxonomy: 'category',
          embeddable: true,
          href: 'http://localhost:8001/wp-json/wp/v2/categories?post=2150',
        },
        {
          taxonomy: 'post_tag',
          embeddable: true,
          href: 'http://localhost:8001/wp-json/wp/v2/tags?post=2150',
        },
        {
          taxonomy: 'tax-house',
          embeddable: true,
          href: 'http://localhost:8001/wp-json/wp/v2/tax-house?post=2150',
        },
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true,
        },
      ],
    },
  },
  {
    title: 'News 2',
    author_img: 'https://media.culture-fid.fr/cercle-reclamation.png',
    author_name: 'Culture Fid',
    news_date: new Date('2021-01-23 16:33:44'),
    thumbnail_img: '',
    short_description:
      'Has autem provincias, quas Orontes ambiens amnis imosque pedes Cassii montis illius celsi praetermeans funditur in Parthenium mare, Gnaeus Pompeius superato Tigrane regnis Armeniorum abstractas dicioni Romanae coniunxit.',
    description: "<h3>Contenu de l'article</h3><p>blablabla</p>",
  },
  {
    title: 'News 3',
    author_img: 'https://media.culture-fid.fr/cercle-reclamation.png',
    author_name: 'Culture Fid',
    news_date: new Date('2021-01-23 16:33:44'),
    thumbnail_img: '',
    short_description:
      'Has autem provincias, quas Orontes ambiens amnis imosque pedes Cassii montis illius celsi praetermeans funditur in Parthenium mare, Gnaeus Pompeius superato Tigrane regnis Armeniorum abstractas dicioni Romanae coniunxit.',
    description: "<h3>Contenu de l'article</h3><p>blablabla</p>",
  },
  {
    title: 'News 4',
    author_img: 'https://media.culture-fid.fr/cercle-reclamation.png',
    author_name: 'Culture Fid',
    news_date: new Date('2021-01-23 16:33:44'),
    thumbnail_img: 'https://media.culture-fid.fr/maintenance.png',
    short_description:
      'Has autem provincias, quas Orontes ambiens amnis imosque pedes Cassii montis illius celsi praetermeans funditur in Parthenium mare, Gnaeus Pompeius superato Tigrane regnis Armeniorum abstractas dicioni Romanae coniunxit.',
    description: "<h3>Contenu de l'article</h3><p>blablabla</p>",
  },
];

const EVENTS = [
  {
    id: 1796,
    date: '2021-10-20T03:19:43',
    date_gmt: '2021-10-20T01:19:43',
    guid: {
      rendered: 'http://localhost:8001/?post_type=event&#038;p=1796',
    },
    modified: '2021-12-06T15:24:08',
    modified_gmt: '2021-12-06T14:24:08',
    slug: 'la-cite-confinee',
    status: 'publish',
    type: 'event',
    link: 'http://localhost:8001/event/la-cite-confinee/',
    title: {
      rendered: 'La Cité Confinée',
    },
    content: {
      rendered:
        '<p>Exposition de photographies de Marta Nascimento.<br />Le 17 mars 2020, la France a connu son premier confinement, une mesure sanitaire mise en place pour lutter contre la propagation de l&rsquo;épidémie de Covid-19, qui a limité fortement les déplacements extérieurs au strict nécessaire.<br />Pendant ce confinement, la Cité internationale est restée très dynamique et fidèle à ses valeurs de solidarité et de dialogue des cultures. Dans leurs maisons, aux fenêtres ou sur les réseaux sociaux, les résidents ont joué de la musique, lancé des challenges, créé des potagers, organisé des cours virtuels de dessin et de cuisine, des débats en ligne, des défilés de mode et même un concours de récits sur le confinement. Les alumni se sont également mobilisés, proposant des cours gratuits de yoga et de danse en live sur les réseaux sociaux.<br />Une ambiance créative et solidaire a ainsi pu être maintenue sur le campus. Découvrez ces images d’un temps suspendu, sous l’objectif de Marta Nascimento, journaliste et reporter photographique brésilienne.</p>\n<p>Biographie</p>\n<p>Née à Rio de Janeiro, Marta Nascimento étudie le journalisme et se consacre au reportage photographique. Depuis 1995, elle vit en France et réalise des sujets sociaux.</p>\n<p>A travers ses rencontres avec des ouvriers, des militants altermondialistes, des aventuriers, des migrants, elle témoigne des dérives de la mondialisation, des mutations du monde du travail ou de la destruction écologique en Amazonie. Elle donne un visage humain à la transformation du monde.<br />Ses reportages ont été publiés dans de nombreux magazines français et internationaux : Marie Claire, L’Obs, La Vie, Le Point, Courrier International, Time, Forbes…<br />Depuis la révolution numérique, elle s’intéresse aussi aux nouvelles formes de narration.</p>\n<p>Pour France 5, elle réalise le webdocumentaire Made in Honduras, une enquête sur les conditions de vie des ouvrières de la zone franche de San Pedro Sula, au Honduras.</p>\n<p>En commande pour la Cité des Sciences, dans le cadre de l’exposition Mutations Urbaines, elle réalise des films où photographies et vidéo interagissent : Regards de migrants sur la ville (Rio de Janeiro) et Mal logés, regards sur la ville (Paris).</p>\n',
      protected: false,
    },
    excerpt: {
      rendered:
        '<p>Exposition de photographies de Marta Nascimento.Le 17 mars 2020, la France a connu son premier confinement, une mesure sanitaire mise&#8230;</p>\n',
      protected: false,
    },
    author: 80,
    featured_media: 1798,
    menu_order: 0,
    comment_status: 'open',
    ping_status: 'closed',
    template: '',
    'tax-house': [23],
    'tax-tag': [26],
    fimg_url:
      'http://localhost:8001/wp-content/uploads/2021/11/web-Citescope-4-4.jpg',
    acf: {
      external_id: '8054',
      external_url: 'https://www.citescope.fr/evenement/la-cite-confinee/',
      external_mtime: 'Wed Oct 20 01:19:43 CEST 2021',
      organizer: 23,
      origin: 'citescope',
      start: '2021-01-28 00:00:00',
      end: '2021-12-31 00:00:00',
      visibility: {
        value: 'public',
        label: 'Public (Visible pour tous les résidents)',
      },
      locations: [
        {
          name: 'Espace d’exposition en plein air',
          url: '',
        },
      ],
      practical:
        '<p><span style="text-decoration: underline;">DATE :</span> Jusqu&rsquo;au 31 décembre 2021<br />Tous les jours</p>\n<p><span style="text-decoration: underline;">HORAIRES :</span> De 8h à 20h</p>\n<p><span style="text-decoration: underline;">TARIFS :</span> Entrée libre et gratuite</p>\n<p><span style="text-decoration: underline;">INFOS :</span> L&rsquo;espace d’exposition en plein air est situé sur la promenade à l&rsquo;arrière de la Fondation Victor Lyon.</p>\n',
    },
    _links: {
      self: [
        {
          href: 'http://localhost:8001/wp-json/wp/v2/event/1796',
        },
      ],
      collection: [
        {
          href: 'http://localhost:8001/wp-json/wp/v2/event',
        },
      ],
      about: [
        {
          href: 'http://localhost:8001/wp-json/wp/v2/types/event',
        },
      ],
      author: [
        {
          embeddable: true,
          href: 'http://localhost:8001/wp-json/wp/v2/users/80',
        },
      ],
      replies: [
        {
          embeddable: true,
          href: 'http://localhost:8001/wp-json/wp/v2/comments?post=1796',
        },
      ],
      'wp:featuredmedia': [
        {
          embeddable: true,
          href: 'http://localhost:8001/wp-json/wp/v2/media/1798',
        },
      ],
      'wp:attachment': [
        {
          href: 'http://localhost:8001/wp-json/wp/v2/media?parent=1796',
        },
      ],
      'wp:term': [
        {
          taxonomy: 'tax-house',
          embeddable: true,
          href: 'http://localhost:8001/wp-json/wp/v2/tax-house?post=1796',
        },
        {
          taxonomy: 'tax-tag',
          embeddable: true,
          href: 'http://localhost:8001/wp-json/wp/v2/tax-tag?post=1796',
        },
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true,
        },
      ],
    },
  },
  {
    title: 'Event 1',
    location: 'Culture Fid',
    event_start_date: new Date('2021-01-23 09:30:00'),
    event_end_date: new Date('2021-01-27 21:00:00'),
    thumbnail_img: 'https://media.culture-fid.fr/maintenance.png',
    description: "<h3>Contenu de l'article</h3><p>blablabla</p>",
    tags: 'Citéscope, CIUP',
  },
  {
    title: 'Event 2',
    location: 'Culture Fid',
    event_start_date: new Date('2021-02-23 09:30:00'),
    event_end_date: new Date('2021-02-27 21:00:00'),
    thumbnail_img: 'https://media.culture-fid.fr/maintenance.png',
    description: "<h3>Contenu de l'article</h3><p>blablabla</p>",
    tags: 'Citéscope, CIUP',
  },
  {
    title: 'Event 3',
    location: 'Culture Fid',
    event_start_date: new Date('2021-01-23 09:30:00'),
    event_end_date: new Date('2021-01-27 21:00:00'),
    thumbnail_img: 'https://media.culture-fid.fr/maintenance.png',
    description: "<h3>Contenu de l'article</h3><p>blablabla</p>",
    tags: 'Citéscope, CIUP',
  },
  {
    title: 'Event 4',
    location: 'Culture Fid',
    event_start_date: new Date('2021-01-23 09:30:00'),
    event_end_date: new Date('2021-01-27 21:00:00'),
    thumbnail_img: 'https://media.culture-fid.fr/maintenance.png',
    description: "<h3>Contenu de l'article</h3><p>blablabla</p>",
    tags: 'Citéscope, CIUP',
  },
];

const HOUSENEWS = [
  {
    title: "Evadez-vous sur l'Île-de-Bréhat !",
    author_img:
      'https://images.unsplash.com/photo-1557130680-6a87a704ac0b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80',
    author_name: "Maison de l'Italie",
    news_date: new Date('2021-01-23 16:33:44'),
    thumbnail_img:
      'https://images.unsplash.com/photo-1557130680-6a87a704ac0b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80',
    short_description:
      "La Cité internationale vous propose de louer une maison sur l'île bretonne de Bréhat, la Fondation Haraucourt, donation du poète Haraucourt à la Cité internationale.",
    description:
      '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nec magna sagittis, ultrices nulla non, posuere quam. Praesent eu urna eu sem laoreet interdum. In magna ex, lobortis nec nisl at, molestie iaculis augue. Suspendisse ut neque varius, ultricies tellus ac, feugiat diam. Suspendisse ut nunc ante. Phasellus id mollis ipsum, eu tempor urna. Nullam a quam ut sem aliquet tempor. Morbi massa elit, porttitor id euismod sed, aliquet sed turpis. Nulla facilisi. Suspendisse porta euismod metus vel mattis. Aliquam at dolor nec dui maximus fringilla eu vel nisl. Donec facilisis augue eget laoreet ultricies. Integer semper, nibh vitae finibus mattis, dui elit mattis velit, in posuere nibh augue nec magna. Nullam accumsan eu odio ut aliquam. Suspendisse fringilla dolor eget lectus accumsan, a egestas mi pharetra. Morbi interdum tempor dictum. Vivamus suscipit, sem at ultricies luctus, dui nisl tincidunt mauris, sit amet lobortis neque ex ac quam. Nullam tempor, diam id pulvinar bibendum, urna leo iaculis neque, luctus fringilla ligula mauris vitae lorem. Cras lacinia rhoncus libero, quis volutpat libero ornare ut. Aliquam molestie leo dui, ut imperdiet lacus tempor non.</p>',
  },
  {
    title: "Evadez-vous sur l'Île-de-Bréhat 2 !",
    author_img:
      'https://images.unsplash.com/photo-1557130680-6a87a704ac0b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80',
    author_name: "Maison de l'Italie",
    news_date: new Date('2021-01-23 16:33:44'),
    thumbnail_img:
      'https://images.unsplash.com/photo-1557130680-6a87a704ac0b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80',
    short_description:
      "La Cité internationale vous propose de louer une maison sur l'île bretonne de Bréhat, la Fondation Haraucourt, donation du poète Haraucourt à la Cité internationale.",
    description:
      '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nec magna sagittis, ultrices nulla non, posuere quam. Praesent eu urna eu sem laoreet interdum. In magna ex, lobortis nec nisl at, molestie iaculis augue. Suspendisse ut neque varius, ultricies tellus ac, feugiat diam. Suspendisse ut nunc ante. Phasellus id mollis ipsum, eu tempor urna. Nullam a quam ut sem aliquet tempor. Morbi massa elit, porttitor id euismod sed, aliquet sed turpis. Nulla facilisi. Suspendisse porta euismod metus vel mattis. Aliquam at dolor nec dui maximus fringilla eu vel nisl. Donec facilisis augue eget laoreet ultricies. Integer semper, nibh vitae finibus mattis, dui elit mattis velit, in posuere nibh augue nec magna. Nullam accumsan eu odio ut aliquam. Suspendisse fringilla dolor eget lectus accumsan, a egestas mi pharetra. Morbi interdum tempor dictum. Vivamus suscipit, sem at ultricies luctus, dui nisl tincidunt mauris, sit amet lobortis neque ex ac quam. Nullam tempor, diam id pulvinar bibendum, urna leo iaculis neque, luctus fringilla ligula mauris vitae lorem. Cras lacinia rhoncus libero, quis volutpat libero ornare ut. Aliquam molestie leo dui, ut imperdiet lacus tempor non.</p>',
  },
  {
    title: "Evadez-vous sur l'Île-de-Bréhat 3 !",
    author_img:
      'https://images.unsplash.com/photo-1557130680-6a87a704ac0b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80',
    author_name: "Maison de l'Italie",
    news_date: new Date('2021-01-23 16:33:44'),
    thumbnail_img:
      'https://images.unsplash.com/photo-1557130680-6a87a704ac0b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80',
    short_description:
      "La Cité internationale vous propose de louer une maison sur l'île bretonne de Bréhat, la Fondation Haraucourt, donation du poète Haraucourt à la Cité internationale.",
    description:
      '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nec magna sagittis, ultrices nulla non, posuere quam. Praesent eu urna eu sem laoreet interdum. In magna ex, lobortis nec nisl at, molestie iaculis augue. Suspendisse ut neque varius, ultricies tellus ac, feugiat diam. Suspendisse ut nunc ante. Phasellus id mollis ipsum, eu tempor urna. Nullam a quam ut sem aliquet tempor. Morbi massa elit, porttitor id euismod sed, aliquet sed turpis. Nulla facilisi. Suspendisse porta euismod metus vel mattis. Aliquam at dolor nec dui maximus fringilla eu vel nisl. Donec facilisis augue eget laoreet ultricies. Integer semper, nibh vitae finibus mattis, dui elit mattis velit, in posuere nibh augue nec magna. Nullam accumsan eu odio ut aliquam. Suspendisse fringilla dolor eget lectus accumsan, a egestas mi pharetra. Morbi interdum tempor dictum. Vivamus suscipit, sem at ultricies luctus, dui nisl tincidunt mauris, sit amet lobortis neque ex ac quam. Nullam tempor, diam id pulvinar bibendum, urna leo iaculis neque, luctus fringilla ligula mauris vitae lorem. Cras lacinia rhoncus libero, quis volutpat libero ornare ut. Aliquam molestie leo dui, ut imperdiet lacus tempor non.</p>',
  },
  {
    title: "Evadez-vous sur l'Île-de-Bréhat 4 !",
    author_img:
      'https://images.unsplash.com/photo-1557130680-6a87a704ac0b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80',
    author_name: "Maison de l'Italie",
    news_date: new Date('2021-01-23 16:33:44'),
    thumbnail_img:
      'https://images.unsplash.com/photo-1557130680-6a87a704ac0b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80',
    short_description:
      "La Cité internationale vous propose de louer une maison sur l'île bretonne de Bréhat, la Fondation Haraucourt, donation du poète Haraucourt à la Cité internationale.",
    description:
      '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nec magna sagittis, ultrices nulla non, posuere quam. Praesent eu urna eu sem laoreet interdum. In magna ex, lobortis nec nisl at, molestie iaculis augue. Suspendisse ut neque varius, ultricies tellus ac, feugiat diam. Suspendisse ut nunc ante. Phasellus id mollis ipsum, eu tempor urna. Nullam a quam ut sem aliquet tempor. Morbi massa elit, porttitor id euismod sed, aliquet sed turpis. Nulla facilisi. Suspendisse porta euismod metus vel mattis. Aliquam at dolor nec dui maximus fringilla eu vel nisl. Donec facilisis augue eget laoreet ultricies. Integer semper, nibh vitae finibus mattis, dui elit mattis velit, in posuere nibh augue nec magna. Nullam accumsan eu odio ut aliquam. Suspendisse fringilla dolor eget lectus accumsan, a egestas mi pharetra. Morbi interdum tempor dictum. Vivamus suscipit, sem at ultricies luctus, dui nisl tincidunt mauris, sit amet lobortis neque ex ac quam. Nullam tempor, diam id pulvinar bibendum, urna leo iaculis neque, luctus fringilla ligula mauris vitae lorem. Cras lacinia rhoncus libero, quis volutpat libero ornare ut. Aliquam molestie leo dui, ut imperdiet lacus tempor non.</p>',
  },
  {
    title: "Evadez-vous sur l'Île-de-Bréhat 5 !",
    author_img:
      'https://images.unsplash.com/photo-1557130680-6a87a704ac0b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80',
    author_name: "Maison de l'Italie",
    news_date: new Date('2021-01-23 16:33:44'),
    thumbnail_img:
      'https://images.unsplash.com/photo-1557130680-6a87a704ac0b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80',
    short_description:
      "La Cité internationale vous propose de louer une maison sur l'île bretonne de Bréhat, la Fondation Haraucourt, donation du poète Haraucourt à la Cité internationale.",
    description:
      '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nec magna sagittis, ultrices nulla non, posuere quam. Praesent eu urna eu sem laoreet interdum. In magna ex, lobortis nec nisl at, molestie iaculis augue. Suspendisse ut neque varius, ultricies tellus ac, feugiat diam. Suspendisse ut nunc ante. Phasellus id mollis ipsum, eu tempor urna. Nullam a quam ut sem aliquet tempor. Morbi massa elit, porttitor id euismod sed, aliquet sed turpis. Nulla facilisi. Suspendisse porta euismod metus vel mattis. Aliquam at dolor nec dui maximus fringilla eu vel nisl. Donec facilisis augue eget laoreet ultricies. Integer semper, nibh vitae finibus mattis, dui elit mattis velit, in posuere nibh augue nec magna. Nullam accumsan eu odio ut aliquam. Suspendisse fringilla dolor eget lectus accumsan, a egestas mi pharetra. Morbi interdum tempor dictum. Vivamus suscipit, sem at ultricies luctus, dui nisl tincidunt mauris, sit amet lobortis neque ex ac quam. Nullam tempor, diam id pulvinar bibendum, urna leo iaculis neque, luctus fringilla ligula mauris vitae lorem. Cras lacinia rhoncus libero, quis volutpat libero ornare ut. Aliquam molestie leo dui, ut imperdiet lacus tempor non.</p>',
  },
];

const COMITE = [
  // 5 max...
  {
    name: 'Michael',
    role: 'Co-Founder / CTO',
    imageUrl:
      'https://images.unsplash.com/photo-1557130680-6a87a704ac0b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80',
  },
  {
    name: 'Luca',
    role: 'Co-Founder / CTO',
    imageUrl:
      'https://images.unsplash.com/photo-1554526735-fca5ffabeb31?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1234&q=80',
  },
  {
    name: 'Angelica',
    role: 'Co-Founder / CTO',
    imageUrl:
      'https://images.unsplash.com/photo-1627683566270-bf7e75dfec0a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1316&q=80',
  },
  {
    name: 'Claudio',
    role: 'Co-Founder / CTO',
    imageUrl:
      'https://images.unsplash.com/photo-1605462863863-10d9e47e15ee?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2850&q=80',
  },
  {
    name: 'Lola',
    role: 'Co-Founder / CTO',
    imageUrl:
      'https://images.unsplash.com/photo-1625477238092-3b6f136cf551?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1234&q=80',
  },
];

const RESIDENTS = [
  //  5 max...
  {
    name: 'Michael',
    imageUrl:
      'https://images.unsplash.com/photo-1557130680-6a87a704ac0b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80',
  },
  {
    name: 'Luca',
    imageUrl:
      'https://images.unsplash.com/photo-1554526735-fca5ffabeb31?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1234&q=80',
  },
  {
    name: 'Angelica',
    imageUrl:
      'https://images.unsplash.com/photo-1627683566270-bf7e75dfec0a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1316&q=80',
  },
  {
    name: 'Claudio',
    imageUrl:
      'https://images.unsplash.com/photo-1605462863863-10d9e47e15ee?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2850&q=80',
  },
];

const USERS = [
  {
    id: 77,
    name: 'Rprénom Rnom',
    email: '',
    acf: {
      mobilephone: '',
      photo: '',
      user_house: [
        {
          term_id: 20,
          name: 'Fondation Hellénique',
          slug: 'fondation-hellenique',
          term_group: 0,
          term_taxonomy_id: 20,
          taxonomy: 'tax-house',
          description: '',
          parent: 0,
          count: 24,
          filter: 'raw',
        },
      ],
    },
    in_my_network: false,
    _links: {
      self: [
        {
          href: 'http://localhost:8001/wp-json/wp/v2/users/77',
        },
      ],
      collection: [
        {
          href: 'http://localhost:8001/wp-json/wp/v2/users',
        },
      ],
    },
  },
  {
    enable: true,
    name: 'Albert Flores',
    house: "Maison de l'Italie",
    avatar:
      'https://images.unsplash.com/photo-1635504426924-44ad366b187b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1374&q=80',
    phone: '07 96 34 12 09',
    mail: 'd.steward@gmail.com',
  },
  {
    enable: false,
    name: 'Brooklyn Simmons',
    house: "Maison de l'Italie",
    avatar:
      'https://images.unsplash.com/photo-1635549298330-186987c31a26?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1374&q=80',
    phone: '07 96 34 12 09',
    mail: 'd.steward@gmail.com',
  },
  // More people...
];

export class MockService {
  private static instance: MockService | undefined;

  public static get Instance(): MockService {
    if (!this.instance) {
      this.instance = new MockService();
      this.instance.init();
    }

    return this.instance;
  }

  private init(): void {}

  public getAccessToken(): string | undefined {
    return '';
  }

  public getIdToken(): string | undefined {
    return '';
  }

  public getHouses() {
    // TODO
  }

  public getCheckList() {
    return CHECKLIST;
  }

  public getAllCheckList() {
    return ALLCHECKLIST;
  }

  public getNewsList() {
    return NEWS;
  }

  public getEventsList() {
    return EVENTS;
  }

  public getHouseNewsList() {
    return HOUSENEWS;
  }

  public getResidents() {
    return RESIDENTS;
  }

  public getComite() {
    return COMITE;
  }

  public getUsersList() {
    return USERS;
  }
}
